var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesPhotoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.57 63.76L140.5 121.69C140.416 122.649 139.955 123.536 139.219 124.157C138.482 124.777 137.53 125.08 136.57 125L85 120.48C84.0406 120.396 83.1536 119.935 82.5332 119.199C81.9128 118.462 81.6096 117.51 81.69 116.55L87.56 49.47C87.6464 48.5097 88.1092 47.6227 88.8474 47.0025C89.5856 46.3824 90.5392 46.0795 91.5 46.16L134.5 49.93L145.57 63.76Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.73 38.7L92.8001 39.92L91.5801 25.99L106.73 38.7Z",
    fill: "#B4C5D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.73 38.7L92.8001 39.92L91.5801 25.99L106.73 38.7Z",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2399 79.97C30.7079 79.97 34.3299 76.348 34.3299 71.88C34.3299 67.4121 30.7079 63.79 26.2399 63.79C21.7719 63.79 18.1499 67.4121 18.1499 71.88C18.1499 76.348 21.7719 79.97 26.2399 79.97Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.79 38.8601L105.16 43.0001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.16 88.53L103.64 86.74L112.83 76.26L116.85 82.3L119.13 79.91L124.16 88.53Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.63 74C125.59 74.4617 125.415 74.9012 125.125 75.2629C124.836 75.6245 124.445 75.8921 124.003 76.0317C123.562 76.1713 123.088 76.1766 122.644 76.0469C122.199 75.9173 121.803 75.6585 121.505 75.3034C121.207 74.9482 121.022 74.5128 120.972 74.0521C120.922 73.5915 121.01 73.1265 121.225 72.7159C121.44 72.3054 121.772 71.9678 122.178 71.746C122.585 71.5242 123.049 71.4282 123.51 71.47C124.125 71.5285 124.692 71.8267 125.089 72.3002C125.486 72.7736 125.68 73.3843 125.63 74Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.76 103.46L55 105.25C54.5236 105.301 54.0418 105.257 53.5824 105.122C53.123 104.986 52.695 104.76 52.3231 104.458C51.9513 104.156 51.6429 103.783 51.4158 103.361C51.1888 102.939 51.0474 102.477 51 102L45.17 34.8599C45.0895 33.9018 45.3914 32.9508 46.0097 32.2145C46.6279 31.4781 47.5124 31.0164 48.47 30.9299L91.47 27.1699",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1299 76.47L78.5499 74.77",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.75 83.4799L77.58 81.9199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3501 90.42L76.2601 89.03",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6299 53.1399L79.7099 51.1199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2402 60.15L78.5502 58.29",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0901 112.56L24.5001 122.35C23.5693 122.595 22.5796 122.462 21.7462 121.981C20.9128 121.5 20.3032 120.709 20.0501 119.78L2.62008 54.73C2.37278 53.8005 2.50453 52.8108 2.9864 51.9783C3.46827 51.1458 4.26085 50.5386 5.19008 50.29L38.8401 41.29",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6001 93.28L42.4301 88.24",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4199 100.08L42.7199 95.45",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2202 106.81L42.6502 102.68",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 63.94L133.57 62.72L134.79 48.78",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1699 101.47L130.97 104.69",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5601 108.41L125.8 111.23",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1077 64.7367L96.7476 91.7136L130.289 94.6482L132.65 67.6712L99.1077 64.7367Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesPhotoGrey);
export default __webpack_public_path__ + "static/media/pages_photo_grey.6026fef4555b36759912d9cf58d984e0.svg";
export { ForwardRef as ReactComponent };